export const apiUrl = 'https://self-service-api.mit.ovotech.org.uk';
export const authTokenStorageKey = 'token';
